'use client';

import Link from 'next/link';
import PartnerForgotPasswordForm from './PartnerForgotPasswordForm';
import styles from './partnerForgotPasswordContent.module.scss';
import { usePartnerAccountRedirect } from '@/hooks/usePartnerAccountRedirect';
import { useMemo, useState } from 'react';

export type FormSteps = 'email' | 'otp' | 'reset';

export default function PartnerForgotPasswordContent() {
  usePartnerAccountRedirect();
  const [step, setStep] = useState<FormSteps>('email');

  const stepTitle = useMemo(() => {
    switch (step) {
      case 'email':
        return 'Forgot your partner password?';
      case 'reset':
        return 'Reset your password';
      default:
        return '';
    }
  }, [step]);

  const stepSubtitle = useMemo(() => {
    switch (step) {
      case 'email':
        return 'Enter your email to reset it.';
      case 'reset':
        return 'Set a new password for your account.';
      default:
        return '';
    }
  }, [step]);

  return (
    <main className={styles.main}>
      {step !== 'otp' && (
        <div className={styles.header}>
          <h1 className={styles.title}>{stepTitle}</h1>
          <p className={styles.subtitle}>{stepSubtitle}</p>
        </div>
      )}

      <PartnerForgotPasswordForm step={step} setStep={setStep} />

      <div className={styles.footer}>
        Remembered your password?{' '}
        <Link href="/partner" className={styles.loginLink}>
          Log in
        </Link>
      </div>
    </main>
  );
}
